/**
 * @file LocationView.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Monday, 1st June 2020 12:33:10 pm
 * @copyright 2019 - 2020 SKAT LLC, Delive LLC
 * @flow
 */
import type { Arrow, iLogger, LocationPoint, iExposedView } from '../../types'

import * as React from 'react'
import Map from './Map.js'
import { Inject } from '../../serviceLocator'

export type Props = {
  center: [number, number],
  point?: LocationPoint,
  cityId?: number
}

export type State = {
  point?: LocationPoint
}

class LocationView extends React.Component<Props, State> implements iExposedView<?LocationPoint> {
  @Inject addressProvider : {reverseGeocode: Function}
  @Inject logger: iLogger

  constructor (props: Props) {
    super(props)
    this.state = {
      point: props.point
    }
  }

  async data () : Promise<?LocationPoint> {
    return this.state.point
  }

  async command () {}

  handleClick : Arrow = (options: { latLng: [number, number]}) => {
    if (!this.addressProvider) { // Web-panel can't provide addressProvider by itself
      this.logger.warn('This component requires "addressProvider" with "reverseGeocode" method')
      return
    }

    const [latitude, longitude] = options.latLng
    this.setState({ point: { latitude, longitude, pointName: '⇣' } })
  }

  async componentDidUpdate (prevProps: Props, prevState: State) {
    if (!this.addressProvider) { // Web-panel can't provide addressProvider by itself
      this.logger.warn('This component requires "addressProvider" with "reverseGeocode" method')
      return
    }

    const point = this.state.point
    const prevPoint = prevState.point
    if (point && (!prevPoint || prevPoint.latitude !== point.latitude)) {
      const { latitude, longitude } = point
      const cityId = this.props.cityId
      const [response] = await this.addressProvider.reverseGeocode({ where: { latitude, longitude, cityId } })
      if (response) {
        const { street, house, regionId } = response
        this.setState({
          point: {
            latitude, longitude, street, house, regionId
          }
        })
      }
    }
  }

  render () : React.Node {
    const { center } = this.props
    const { point } = this.state
    const waypoints = point ? [point] : []
    return (
      <div className='location-view h400px'>
        <Map waypoints={waypoints} center={center} onClick={this.handleClick} />
      </div>
    )
  }
}

export default LocationView
